






























































import {Component, Mixins} from 'vue-property-decorator';
import EditDialogMixin from '@/mixins/dialog/EditDialogMixin';
import CEditDialog from '@/components/base/dialog/CEditDialog.vue';
import CTextField from '@/components/base/textField/CTextField.vue';
import CCombobox from '@/components/base/combobox/CCombobox.vue';
import CCheckbox from '@/components/base/checkbox/CCheckbox.vue';
import CTable from '@/components/base/table/CTable.vue';
import CSelect from '@/components/base/select/CSelect.vue';
@Component({
    components: {CSelect, CTable, CCheckbox, CCombobox, CTextField, CEditDialog},
})
export default class CompanyEditDialog extends Mixins(EditDialogMixin) {
    errorKeyList = {
        Name: 'Name',
    };

    get tableHeaders() {
        return [
            {
                value: 'IdCalculationType',
                text: this.$t('Systems.Company.DefaultCalculationType'),
                sort: this.getDescriptionsContainer().getSortFn(
                    this.addDescriptionPostfix(this.$api.catalogues.calculationType),
                ),
            },
            {
                value: 'IdPlanOrderType',
                text: this.$t('Systems.Company.DefaultPlanOrderType'),
                sort: this.getDescriptionsContainer().getSortFn(
                    this.addDescriptionPostfix(this.$api.catalogues.planOrderType),
                ),
            },
            {
                value: 'IdPlanPriorityOrderType',
                text: this.$t('Systems.Company.DefaultPlanPriorityOrderType'),
                sort: this.getDescriptionsContainer().getSortFn(
                    this.addDescriptionPostfix(this.$api.catalogues.planPriorityOrderType),
                ),
            },
        ];
    }
}
